<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div>
        <span style="font-size: 13px; color:#97a8be">首页 / 项目管理 / 公司列表</span>
      </div>
    </div>
    <div style="overflow:hidden; padding:15px 15px; padding-top: 0; line-height: 43px ">
      <span class="leftTd">项目ID</span>
      <input class="boxText" v-model="code" style="width: 200px; margin-left: 10px;">

      <input @click="selectAdminList" type="button" style="cursor: pointer; padding: 7px 25px; border-radius: 3px; margin-left: 10px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="搜索" />
    </div>
    <div style="overflow:hidden; padding:0 15px;">
      <div @click="addAdmin" class="addBtn">+ 添加公司</div>
    </div>
    <div style="padding: 10px 15px">
      <div style="overflow-x: scroll">
        <table>
          <tr>
            <th class="th">
              操作
            </th>
            <th class="th">
              项目ID
            </th>
            <th class="th">
              公司名称
            </th>
            <th class="th">
              公司地址
            </th>
            <th class="th">
              公司类型
            </th>
            <th class="th">
              所属行业
            </th>
            <th class="th">
              所属地域
            </th>
            <th class="th">
              曾用名
            </th>
            <th class="th">
              董事长
            </th>
            <th class="th">
              董秘
            </th>
            <th class="th">控股股东</th>
            <th class="th">经营性质</th>
            <th class="th">员工人数</th>
            <th class="th">上市日期</th>
          </tr>
          <tr :key="index" v-for="(value,index) in adminList">
            <td class="td">
              <div style="overflow: hidden;min-width: 150px;">
                <div @click="updateAdmin(value)" style="cursor: pointer; float: left; color: #1890ff">
                  编辑
                </div>
                <div @click="deleteProject(value.companyId)" style="cursor: pointer; margin-left: 10px; float: left; color: #1890ff">
                  删除
                </div>
              </div>
            </td>
            <td class="td">
              {{ value.companyProject }}
            </td>
            <td class="td">
              {{ value.companyName }}
            </td>
            <td class="td">
              {{ value.companyAddress }}
            </td>
            <td class="td">
              {{value.companyType}}
            </td>
            <td class="td">
              {{value.companyIndustry}}
            </td>
            <td class="td">
              {{value.companyArea}}
            </td>
            <td class="td">
              {{value.companyOldName}}
            </td>
            <td class="td">
              {{value.companyChairman}}
            </td>
            <td class="td">
              {{ value.companyChairmanBorad }}
            </td>
            <td class="td">{{ value.companyKonggu }}</td>
            <td class="td">{{ value.companyBusinessNature }}</td>
            <td class="td">{{ value.companyEmployee }}</td>
            <td class="td">{{ value.companySsTime }}</td>
          </tr>
        </table>
      </div>
      <div style="padding-top: 20px; font-size: 12px; color: #606266; text-align: right">
        一页显示 <input v-model="num" style="text-align: center; width: 30px; min-width: 30px;" class="text1"/>
        条，共<span v-html="count"></span>条数据
        <img src="@/assets/home/shuaxin.png" v-on:click="selectAdminList()" title="刷新"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shouye.png" v-on:click="currPage(1)" title="首页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shangyiye.png" v-on:click="currPage(2)" title="上一页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <input v-model="page" style="text-align: center; width: 30px; min-width: 30px;" class="text1"/> / <span
          v-html="countPage"></span>页
        <img src="@/assets/home/xiayiye.png" v-on:click="currPage(3)" title="下一页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/weiye.png" v-on:click="currPage(5)" title="尾页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shuaxin.png" v-on:click="selectAdminList()" title="刷新"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
      </div>
    </div>
  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost} from "@/main";

export default {
  name: "CompanyList",
  data(){
    return{
      code:"",
      name:"",
      company:"",
      state:"",
      recommend:"",
      adminList:[],
      page:1,
      num:10,
      count:0,
      countPage:0,
      imgUrl:"",
      levelList:[],
      teamLevelList:[]
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    this.selectAdminList()
  },
  methods: {
    deleteProject(id){
      let that=this
      if(confirm("确认删除此公司？")){
        axiosPost(DO_NET_URL+"company/DeleteCompany?id="+id,"",function (res){
          console.log(res)
          if(res.code==200){
            toask("删除成功！",6)
            that.selectAdminList()
          }else{
            toask(res.data,6)
          }
        })
      }
    },
    updateSchedule(id,e){
      if(e==""){
        toask("进度不能为空！",6)
        return
      }
      axiosPost(DO_NET_URL+"project/UpdateSchedule?projectId="+id+"&projectSchedule="+e,function (res){

      })
      console.log(id)
      console.log(e)
    },
    addValue(code){
      localStorage.setItem("userCode",code)
      this.$emit("send","addValue")
    },
    breakProject(code){
      localStorage.setItem("userCode",code)
      this.$emit("send","breakProject")
    },
    childUser(code){
      localStorage.setItem("userCode",code)
      this.$emit("send","childUser")
    },
    updateAdmin(obj){
      localStorage.setItem("UPDATEOBJ",JSON.stringify(obj))
      this.$emit("send",'updateCompany')
    },

    addAdmin(){
      this.$emit("send",'addCompany')
    },
    currPage(num){
      if(num==1){
        this.page=1
      }else if(num==5){
        this.page=this.countPage
      }else if(num==2){
        if(this.page>1){
          this.page-=1
        }
      }else{
        if(this.page<this.countPage){
          this.page+=1
        }
      }
      this.selectAdminList()
    },
    async selectAdminList(){
      let that=this
      loading("加载中")
      axiosGet(DO_NET_URL+"company/GetCompany?id="+this.code+
          "&page="+this.page+"&num="+this.num,function (res){
        console.log(res.data)
        closeLoading()
        that.adminList=res.data.list
        that.count=res.data.num
        let page=parseInt(res.data.num/that.num)
        if(res.data.num%that.num>0){
          page+=1
        }
        that.countPage=page
      })
    },
  }
}
</script>

<style scoped>
.text1{
  border: 1px solid #dcdfe6;
  font-size: 12px;
  border-radius: 2px;
  outline: none;
  padding: 3px 10px;
}
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 35px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700;}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0px 10px; min-width: 100px; width: auto; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>